import {
  FETCH_GLASSBOOKS_SUCCESS,
  FETCH_GLASSBOOKS_FAIL,
} from '../actions/types';

const initialState = {
  glassbooks: [],
  pagination: [],
  errors: [],
  success: [],
};

const history = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GLASSBOOKS_SUCCESS:
      return {
        ...state,
        glassbooks: action.payload.data,
        pagination: action.payload.pagination,
        loading: false,
      };
    case FETCH_GLASSBOOKS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default history;
